import { render, staticRenderFns } from "./MainLay.vue?vue&type=template&id=9a163dec&scoped=true"
import script from "./MainLay.vue?vue&type=script&lang=js"
export * from "./MainLay.vue?vue&type=script&lang=js"
import style0 from "./MainLay.vue?vue&type=style&index=0&id=9a163dec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a163dec",
  null
  
)

export default component.exports